import { emptySplitApi } from "./empty-split-api";
import {
  ProductFamily,
  ProductFamilyRequestBody,
} from "./types/product-family.type";

export const productFamilyApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductFamilies: builder.query<
      ProductFamily[],
      ProductFamilyRequestBody
    >({
      query: (params) => ({
        url: `/product-families/`,
        method: "GET",
        params,
      }),
    }),
  }),
});

export const { useGetProductFamiliesQuery } = productFamilyApi;
